<template>
  <div>
    <div class="bodyElement header">
      <h1 class="bigTitle">Riding Map</h1>
    </div>
    <div class="bodyElement">
      <RidingMap :ridingColors="ridingColors" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RidingMap from "../components/map/RidingMap.vue";

const SWING_COLOR = "#FF0000";

export default {
  name: "RidingMapView",
  components: {
    RidingMap,
  },
  data() {
    return {
      ridingColors: {},
    };
  },
  async mounted() {
    try {
      const response = await axios.get(
        `https://docs.google.com/spreadsheets/d/e/2PACX-1vSHdxj1KPFMHP5gT1ybNfd_-N_7QikiUQ1zMKJgGb4xZjwPY4DcRE6xjWHlWqgbhawjk8ZO6I52MakV/pub?gid=1662116056&single=true&output=csv`,
      );
      const colors = {};
      const lines = response.data.trim().split(/\r?\n/);
      console.log("[RidingMap] raw line 0:", lines[0]);
      console.log("[RidingMap] raw line 1:", lines[1]);
      const parseLine = (line) => line.split(",").map((c) => c.trim());
      const headers = parseLine(lines[0]).map((h) => h.toLowerCase());
      console.log("[RidingMap] headers:", headers);
      const nameCol = headers.findIndex(
        (h) =>
          h.includes("riding") ||
          h.includes("name") ||
          h.includes("constituency"),
      );
      const swingCol = headers.findIndex((h) => h.includes("swing"));
      console.log("[RidingMap] nameCol:", nameCol, "swingCol:", swingCol);

      for (let i = 1; i < lines.length; i++) {
        const cols = parseLine(lines[i]);
        const ridingName = cols[nameCol !== -1 ? nameCol : 0];
        const swingValue = cols[swingCol !== -1 ? swingCol : 1];
        if (ridingName && swingValue === "1") {
          colors[ridingName] = SWING_COLOR;
        }
      }
      console.log("[RidingMap] swing ridings found:", Object.keys(colors));
      this.ridingColors = colors;
    } catch (err) {
      console.error("Failed to fetch riding data:", err);
    }
  },
};
</script>

<style src="../css/app.css"></style>
